import React from 'react';
import { ReactComponent as ModalIcon } from '../../assets/modal.svg';
import { useThemeColor } from '../../hooks/useThemeColor';

const Modal = ({ isOpen, onClose, onYes, onNo, title, children, confirmText = 'Neu starten', cancelText = 'Abbrechen', width = 'max-w-3xl' }) => {
    const { aispaceColor } = useThemeColor();
    
    if (!isOpen) return null;

    return (
        <div
            className="fixed inset-0 bg-black/30 flex justify-center items-start sm:items-center z-[120] p-2 sm:p-4 overflow-y-auto pt-4 pb-4 sm:pt-[210px] sm:pb-[150px]"
            onClick={onClose}>
            <div
                className={`bg-white flex flex-col justify-center items-center rounded-lg pr-4 pl-4 pt-8 pb-8 w-full max-w-[95vw] sm:max-w-2xl md:max-w-3xl lg:${width} text-center mt-4 mb-4 sm:mt-0 sm:mb-0`}
                style={{ boxSizing: 'border-box' }}
                onClick={e => e.stopPropagation()}
            >
                <ModalIcon fill={aispaceColor} className="mb-4 h-16 w-16" />
                <h2 className="text-2xl font-bold mb-4">{title}</h2>
                <div className="mb-6 text-custom-gray w-full px-2 sm:px-4 overflow-y-auto" style={{maxHeight: '50vh'}}>{children}</div>
                <div className="flex justify-end space-x-4 text-black w-full">
                    <button
                        className="px-4 py-2 bg-custom-gray_white text-custom-gray  rounded transition duration-200 flex"
                        onClick={onNo || onClose}
                    >
                        <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M6.9 19L5.5 17.6L11.1 12L5.5 6.4L6.9 5L12.5 10.6L18.1 5L19.5 6.4L13.9 12L19.5 17.6L18.1 19L12.5 13.4L6.9 19Z" fill="#5F6368" />
                        </svg>
                        {cancelText}
                    </button>
                    <button
                        className="px-4 py-2 bg-custom-yellow flex gap-1  rounded transition duration-200"
                        onClick={onYes}
                    >
                        <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M10.0496 18.0001L4.34961 12.3001L5.77461 10.8751L10.0496 15.1501L19.2246 5.9751L20.6496 7.4001L10.0496 18.0001Z" fill="black" />
                        </svg>
                        {confirmText}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default Modal;